import { useCallback, useState } from 'react';

export const useDicomCanvas = () => {
  const [dicomCanvas, setDicomCanvas] = useState<HTMLDivElement | null>(null);

  const dicomCanvasRef = useCallback((node: HTMLDivElement) => {
    setDicomCanvas(node);
  }, []);

  return [dicomCanvas, dicomCanvasRef] as const;
};
